var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CardFormText, PaymentProcessor, StatusType, } from "../Shared/types/PaymentProcessorTypes";
/**
 * Returns the response from Tap after processing
 *
 * @param setToken
 * @param handleSubmit
 * @returns
 */
export const callback = (handleSubmit, onSubmit, createPaymentMethod, updatePaymentMethod, setCardFormState, setAddedNewCard, selectedCard) => (response) => {
    setCardFormState({
        loading: true,
        submitted: true,
        status: {
            message: !!selectedCard ? CardFormText.UPDATE_LOADING_TEXT : CardFormText.ADD_LOADING_TEXT,
            type: StatusType.PROCESSING,
        },
    });
    if (response.id) {
        handleSubmit(onSubmit(response, createPaymentMethod, updatePaymentMethod, setCardFormState, setAddedNewCard, selectedCard))();
    }
    else {
        setCardFormState({
            loading: false,
            submitted: false,
            status: {
                message: `${CardFormText.UNEXPECTED_ERROR} ${CardFormText.PLEASE_TRY_AGAIN}`,
                type: StatusType.ERROR,
            },
        });
    }
};
/**
 * If Tap response is successful, save card to our database
 * @param data
 */
export const onSubmit = (tapData, createPaymentMethod, updatePaymentMethod, setCardFormState, setAddedNewCard, selectedCard) => (formData) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const requestBody = {
        isPrimary: formData.isPrimaryChecked,
        token: tapData.id,
        paymentProcessor: PaymentProcessor.TAP,
        paymentMethodId: selectedCard === null || selectedCard === void 0 ? void 0 : selectedCard.id,
    };
    if (!!selectedCard) {
        try {
            yield updatePaymentMethod(requestBody);
            setCardFormState({
                loading: true,
                submitted: true,
                status: {
                    type: StatusType.SUCCEEDED,
                    message: CardFormText.YOUR_CARD_WAS_UPDATED,
                },
            });
        }
        catch (error) {
            setCardFormState({
                loading: true,
                submitted: true,
                status: {
                    type: StatusType.ERROR,
                    message: `${(error === null || error === void 0 ? void 0 : error.message) || "Failed to update"} ${CardFormText.PLEASE_TRY_AGAIN}`,
                },
            });
        }
    }
    else {
        try {
            yield createPaymentMethod(requestBody);
            setAddedNewCard(true);
            setCardFormState({
                loading: true,
                submitted: true,
                status: {
                    type: StatusType.SUCCEEDED,
                    message: CardFormText.YOUR_CARD_WAS_ADDED,
                },
            });
        }
        catch (error) {
            setCardFormState({
                loading: true,
                submitted: true,
                status: {
                    type: StatusType.ERROR,
                    message: `${(_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : CardFormText.UNEXPECTED_ERROR} ${CardFormText.PLEASE_TRY_AGAIN}`,
                },
            });
        }
    }
});
/**
 * Close modal, clear token and reset form
 *
 * @param setToken
 * @param resetField
 * @returns
 */
export const handleClose = (resetField, setCardFormState) => (onClose) => {
    resetField("isPrimaryChecked");
    onClose();
    setCardFormState({
        loading: false,
        submitted: false,
        status: {
            type: StatusType.IDLE,
            message: "",
        },
    });
};
